import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  deleteStaff(context, payload) {
    ApiService.setHeader();
    return ApiService.delete("school/employee/staff", {
      params: {
        id: payload,
      },
    }).then((response) => response);
  },
};

export default {
  actions,
};
